export default "__VITE_ASSET__DzU9YFUq__"